var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"width":"100vw","position":"sticky","left":"0","top":"0","z-index":"4"},attrs:{"outlined":"","color":_vm.color}},[_c('v-card-title',{staticClass:"text-h6 font-weight-bold justify-center pa-0",style:({ 'color': _vm.textColor })},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }